module.exports = __webpack_public_path__ + "img/icon-info.e4516b41.svg";